import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const S3_IMAGE_BASE = 'https://assets.languify.in/images';

const PARTNER_LOGOS = [
    { id: 1, name: 'Charles University', src: `${S3_IMAGE_BASE}/charles_university.png` },
    { id: 2, name: 'Chicago Booth', src: `${S3_IMAGE_BASE}/chicago_booth.png` },
    { id: 3, name: 'ESSCA', src: `${S3_IMAGE_BASE}/essca.png` },
    { id: 4, name: 'Harvard University', src: `${S3_IMAGE_BASE}/harvard.png` },
    { id: 5, name: 'HEC Paris', src: `${S3_IMAGE_BASE}/hec.png` },
    { id: 6, name: 'IIMA', src: `${S3_IMAGE_BASE}/iima.png` },
    { id: 7, name: 'IIMB', src: `${S3_IMAGE_BASE}/iimb.png` },
    { id: 8, name: 'IIMC', src: `${S3_IMAGE_BASE}/iimc.png` },
    { id: 9, name: 'IIM Kozhikode', src: `${S3_IMAGE_BASE}/iimKozhi.png` },
    { id: 10, name: 'IIM Lucknow', src: `${S3_IMAGE_BASE}/iiml.png` },
    // { id: 11, name: 'IIM Mumbai', src: `${S3_IMAGE_BASE}/iimmumbai.png` },
    { id: 12, name: 'IIM Udaipur', src: `${S3_IMAGE_BASE}/iimu.png` },
    // { id: 13, name: 'IIT BHU', src: `${S3_IMAGE_BASE}/iit_bhu.png` },
    // { id: 14, name: 'IIT Kanpur', src: `${S3_IMAGE_BASE}/iitk.png` },
    { id: 15, name: 'ISB', src: `${S3_IMAGE_BASE}/isb_new.png` },
    // { id: 16, name: 'SRC', src: `${S3_IMAGE_BASE}/src.png` },
    // { id: 17, name: 'Queen Mary University of London', src: `${S3_IMAGE_BASE}/queen_marry.png` },
    { id: 18, name: 'XLRI', src: `${S3_IMAGE_BASE}/xlri_new.png` },
    { id: 19, name: 'Yale School of Management', src: `${S3_IMAGE_BASE}/yale.png` },
];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        padding: '40px 0',
    },
    title: {
        color: '#FFFFFF',
        fontFamily: 'Mulish, sans-serif',
        fontWeight: 500,
        fontSize: '1rem',
        textAlign: 'center',
        marginBottom: '28px',
        letterSpacing: '0.01em',
    },
    marqueeWrapper: {
        overflow: 'hidden',
        width: '100%',
        // Fade edges so logos smoothly disappear at sides
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
        maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
    },
    // Track is duplicated — animating to -50% moves exactly one full set width
    track: {
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        animation: '$scrollLeft 28s linear infinite',
        '&:hover': {
            animationPlayState: 'paused',
        },
    },
    '@keyframes scrollLeft': {
        '0%': { transform: 'translateX(0)' },
        '100%': { transform: 'translateX(-50%)' },
    },
    logoItem: {
        flexShrink: 0,
        margin: '0 12px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        width: '120px',
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            width: '96px',
            height: '48px',
        },
    },
    logoImg: {
        maxWidth: '80%',
        maxHeight: '70%',
        objectFit: 'contain',
    },
    // Shown when src is null — remove once real logos are provided
    logoPlaceholder: {
        width: '60%',
        height: '35%',
        backgroundColor: 'rgba(0,0,0,0.12)',
        borderRadius: '3px',
    },
}));

function UniversitiesCarousal() {
    const classes = useStyles();

    // Duplicate the array so the loop is seamless:
    // animating -50% of the full track moves exactly one copy's worth
    const loopedLogos = [...PARTNER_LOGOS, ...PARTNER_LOGOS];

    return (
        <Box className={classes.root}>
            <Typography className={classes.title}>
                Partners with(College logos)
            </Typography>

            <Box className={classes.marqueeWrapper}>
                <Box className={classes.track}>
                    {loopedLogos.map((logo, index) => (
                        <Box key={index} className={classes.logoItem}>
                            {logo.src
                                ? <img src={logo.src} alt={logo.name} className={classes.logoImg} />
                                : <Box className={classes.logoPlaceholder} />
                            }
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default UniversitiesCarousal;
